import React from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip, Typography } from 'antd'
import classNames from 'classnames'
import dayjs from 'dayjs'
import styles from './SellerCancelPenalty.module.scss'

interface ISellerCancelPenaltyProps {
  cancelCount: number
  commissionPenalty: number
  isDisabledForCancels: boolean
  disabledUntil?: string | null
  isExempt: boolean
}

// Четвёртая отмена за 30 дней отключает магазин, поэтому шкала заканчивается на «4+»
const CANCEL_SCALE = ['0', '1', '2', '3', '4+']

const CANCEL_HINT =
  'Каждая отмена учитывается 30 дней со своей даты, потом выпадает, и надбавка снижается на ступень. Все отмены обнуляются после 10 заказов подряд, переданных в доставку без отмен. 1 отмена — комиссия +5 п.п., 2 — +15 п.п., 3 — +35 п.п., 4-я и следующие — магазин отключается на 14 дней.'

export const SellerCancelPenalty: React.FC<ISellerCancelPenaltyProps> = ({
  cancelCount,
  commissionPenalty,
  isDisabledForCancels,
  disabledUntil,
  isExempt
}) => {
  const currentIndex = Math.min(cancelCount, CANCEL_SCALE.length - 1)

  const renderSanction = () => {
    if (isDisabledForCancels) {
      return (
        <Typography.Text type='danger'>
          Магазин отключён
          {disabledUntil && ` до ${dayjs(disabledUntil).format('DD.MM.YYYY HH:mm')}`}
          {commissionPenalty > 0 && `, комиссия +${commissionPenalty}%`}
        </Typography.Text>
      )
    }
    if (isExempt) {
      return <Typography.Text type='secondary'>не применяются</Typography.Text>
    }
    if (commissionPenalty > 0) {
      return <Typography.Text type='warning'>Комиссия +{commissionPenalty}%</Typography.Text>
    }
    return <Typography.Text type='success'>нет</Typography.Text>
  }

  return (
    <div>
      <Typography.Text className={styles.title}>
        Количество отмен за 30 дней
        <Tooltip title={CANCEL_HINT}>
          <QuestionCircleOutlined className={styles.hint} />
        </Tooltip>
      </Typography.Text>
      <div className={classNames(styles.scale, { [styles.exempt]: isExempt })}>
        {CANCEL_SCALE.map((label, index) => (
          <React.Fragment key={label}>
            {index > 0 && (
              <span
                className={classNames(styles.segment, styles[`segment${index}`], {
                  [styles.reached]: index <= currentIndex
                })}
              />
            )}
            <div
              className={classNames(styles.point, styles[`level${index}`], {
                [styles.reached]: index <= currentIndex,
                [styles.current]: index === currentIndex
              })}
            >
              <span className={styles.dot} />
              <span className={styles.label}>{label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className={styles.sanction}>
        <Typography.Text className={styles.sanctionTitle}>Штрафные санкции:</Typography.Text>
        {renderSanction()}
      </div>
    </div>
  )
}
